import type { DocsPageTranslation } from './types'

// Initial LLM-assisted Japanese docs translation. Koh should review this copy
// before release; source_en_hash marks the English source revision used here.
export const DOCS_PAGE_TRANSLATIONS_JA = {
  'getting-started/welcome': {
    source_en_hash: 'v1:1ehqbgkba04',
    title: 'ようこそ',
    description: 'Martiniとは何か、映像制作者がどう使うか。',
    overview: `Martiniは、AI動画のためのフィルムセットです。無限に広がるキャンバス上で、ショットを配置し、AIモデルで生成し、意図した結果になるまで反復し、最後にすべてをタイムラインで編集します。高速な試行錯誤、空間的な整理、リアルタイム共同作業のために作られています。

![](/docs-imgs/welcome1.mp4)

||V|| を押してショットを配置します。プロンプトを書き、モデルを選び、生成します。テイクが合わなければ、プロンプトを調整したり、参照画像を差し替えたり、別のモデルを試したりします。新しいテイクは元のテイクの横に残るので、比較できます。

![](/docs-imgs/welcome2.mp4)

必要なショットが揃ったら、タイムラインにドラッグして書き出します。MartiniはVeo、Kling、Soraなどのモデルを一つの画面で扱えるため、ショットに合うモデルを選べます。`,
  },
  'getting-started/first-shot': {
    source_en_hash: 'v1:1516v8f2dr5',
    title: '最初のショット',
    description: '画像を生成し、それを動画にします。',
    overview: `すべてのプロジェクトは空のキャンバスから始まります。||V|| を押してショットを配置し、プロンプトを書き、モデルを選んで生成します。これが基本のワークフローです。あとは反復です。

Martiniは画像から動画、動画から動画、テキストから動画の生成に対応しています。ショットに合う方法を選んでください。多くの映像制作者は、生成またはアップロードした画像から始め、それを動画の開始フレームとして使います。画像が構図を固定し、モデルが動きを作ります。`,
  },
  'getting-started/iterating': {
    source_en_hash: 'v1:7e0ld19ccr',
    title: 'ショットを反復する',
    description: '素早い反復でショットを磨き込みます。',
    overview: `最初の生成が最終版になることはほとんどありません。プロンプトを書き直し、参照画像を差し替え、別のモデルを試し、尺を調整します。すべてのテイクは元の横に配置されるため、並べて比較できます。

Martiniは、生成、確認、調整、再生成というシンプルなループを中心に設計されています。キャンバスには候補を広げる余白があります。1つのショットを詰めているときは、スタックで関連テイクをまとめられます。`,
  },
  'canvas/overview': {
    source_en_hash: 'v1:24twlaut3dj',
    title: '概要',
    description: 'すべての作業が存在する無限のワークスペース。',
    overview: `キャンバスは無限に広がる2Dワークスペースです。プロジェクト内のショット、画像、音声、セット、テキスト注釈はここに置かれます。ページやフォルダを移動する必要はありません。ライトテーブルにセレクトを並べたり、壁にリファレンスを貼ったりするように、空間的に整理します。

キャンバス上のすべてのオブジェクトは、選択、移動、整理について同じルールに従います。ズームアウトしてプロジェクト全体を見たり、ズームインしてフレームを確認したりできます。スクロールでズーム、2本指ドラッグでパン、||F|| ですべてを画面に収めます。`,
  },
  'canvas/nodes': {
    source_en_hash: 'v1:1wj9a4wqesi',
    title: 'キャンバスオブジェクト',
    description: 'キャンバスに配置できるすべてのオブジェクトタイプ。',
    overview: `ショートカットを押して配置モードに入り、キャンバスをクリックしてオブジェクトを配置します。動画ショットは ||V||、画像は ||I||、テキスト注釈は ||T||、ビンは ||B||、変数は ||Shift V||、セットは ||Shift S||、音声は ||A|| を使います。

それぞれに役割があります。ショットと画像はビジュアル素材を保持します。ライブラリのコレクションは、プロジェクトをまたいでキャラクターや小道具の一貫性を保ちます。変数は再利用するプロンプト断片を保存します。ビンは関連する作業をまとめます。注釈は自分や共同制作者へのメモです。セットはショット生成に使える3D環境です。`,
  },
  'canvas/selection': {
    source_en_hash: 'v1:aigbiuhqie',
    title: '選択',
    description: 'クリック、Shiftクリック、マーキーでキャンバス上の作業を選択します。',
    overview: `クリックで選択します。||Shift|| を押しながらクリックすると選択に追加できます。空いている場所をドラッグするとマーキー選択できます。||⌘A|| はすべてを選択します。||Escape|| は選択を解除します。

選択されたオブジェクトには枠が表示されます。複数選択すれば、複数のオブジェクトをまとめて移動、削除、ラベル付けできます。インスペクターには最後に選択したオブジェクトの詳細が表示されます。

オブジェクトをドラッグすると、内容を変えずに位置を移動できます。複数のオブジェクトを選択している場合は、そのうちの1つをドラッグすると選択全体が相対位置を保ったまま移動します。`,
  },
  'canvas/organizing': {
    source_en_hash: 'v1:28jlsrfkc2l',
    title: '整理',
    description: 'カラーレーベル、レーティング、ビン、フィルター。',
    overview: `||1|| から ||5|| を押すとカラーレーベルを適用できます。||F|| はお気に入り、||R|| はリジェクトです。これはデイリーからセレクトを引く編集者のための仕分けツールです。強いテイクに印を付け、弱いテイクをリジェクトし、残りを整理します。

||B|| を押してビンを作成し、ショットをドラッグしてキャンバス上でグループ化します。ビンはコンテナであり、フォルダではありません。すべては表示されたままアクセスできます。||Shift F|| でフィルターを開き、お気に入り、リジェクト、特定のカラーレーベルに絞り込めます。フィルターは表示だけを変えます。`,
  },
  'canvas/clipboard': {
    source_en_hash: 'v1:19nz99iz0ro',
    title: 'コピー、ペースト、複製',
    description: 'クリップボード操作と素早い複製。',
    overview: `||⌘C|| でコピー、||⌘V|| でペースト、||⌘D|| で複製します。コピーしたオブジェクトは設定を保ったまま、元の近くに貼り付けられます。クリップボードを使わずに素早くコピーしたいときは ||⌘D|| が便利です。

これらの操作は単一オブジェクトにも複数選択にも使えます。5つのショットをコピーしてキャンバスの別の場所に貼り付けると、相対的な位置関係も保たれます。`,
  },
  'canvas/undo-redo': {
    source_en_hash: 'v1:19hh43keqnm',
    title: '取り消しとやり直し',
    description: 'キャンバス操作を戻し、復元します。',
    overview: `||⌘Z|| は直前の操作を取り消します。||⌘ Shift Z|| はやり直しです。取り消しは、移動、削除、名前変更、オブジェクト作成などのキャンバス作業に対応しています。

取り消しは共同作業を考慮しています。戻るのは自分の操作だけで、共同制作者の操作ではありません。誰かが作業中にノードを動かしても、自分の ||⌘Z|| でその移動が戻ることはありません。`,
  },
  'canvas/rename': {
    source_en_hash: 'v1:glr66svv1q',
    title: '名前の変更',
    description: 'キャンバス上で直接名前を変更します。',
    overview: `オブジェクトを選択して ||Enter|| を押すと、名前をインラインで変更できます。新しい名前を入力し、もう一度 ||Enter|| を押して確定します。||Escape|| でキャンセルできます。名前はキャンバス上のオブジェクトの下に表示され、多くのテイクを扱うときの識別に役立ちます。`,
  },
  'canvas/delete': {
    source_en_hash: 'v1:8fw602mwuu',
    title: '削除',
    description: 'キャンバスから作業を削除します。',
    overview: `||Delete|| または ||Backspace|| を押すと、選択したオブジェクトを削除できます。単一オブジェクトにも複数選択にも使えます。削除は取り消せるため、||⌘Z|| で作業を戻せます。`,
  },
  'canvas/playback': {
    source_en_hash: 'v1:1xs0lrqf04s',
    title: '再生',
    description: 'ショットをプレビューし、動画をスクラブします。',
    overview: `||Space|| で再生と一時停止を切り替えます。||J||/||K||/||L|| はスクラブです。||J|| は逆再生、||L|| は再生、||K|| は停止です。||L|| を2回押すと倍速になります。操作はPremiere、Avid、DaVinciと同じです。

ショットを選択して ||Space|| を押すと、キャンバス上でその場プレビューできます。タイムライン上部のプログラムモニターには、現在のフレームがより大きく表示されます。`,
  },
  'generation/overview': {
    source_en_hash: 'v1:65l7fbi17r',
    title: '概要',
    description: 'MartiniでのAI生成の仕組み。',
    overview: `MartiniはVeo、Kling、Soraなど複数のAIモデルに接続します。個別のアカウントやAPIキーは必要ありません。モデルを選び、プロンプトを書き、パラメータを設定して生成します。すべての結果はキャンバスに配置されるため、反復、評価、タイムラインへの編集ができます。

生成は中心となるループです。ショットを配置し、欲しい内容を説明し、モデルを選んで生成します。結果が合わなければ調整して再生成します。キャンバスには、テイクを並べて比較するための空間があります。`,
  },
  'generation/images': {
    source_en_hash: 'v1:2400a89jp95',
    title: '画像',
    description: '静止フレームを生成し、参照として使います。',
    overview: `画像生成は多くの場合、出発点になります。静止フレームを生成し、それを動画生成の参照として使います。写真、ストーリーボード、コンセプトアートをアップロードし、開始フレームやスタイル参照として使うこともできます。

ライブラリのコレクションは、特定の視覚的アイデンティティにモデルを固定することで、ショットをまたいでキャラクターや小道具の一貫性を保ちます。最も鮮明な画像をコレクションに保存し、プロンプトで @ から参照すると、それを参照するすべてのショットで同じ見た目が維持されます。`,
  },
  'generation/video': {
    source_en_hash: 'v1:1smga0lwpzx',
    title: '動画',
    description: 'プロンプトと参照から動くショットを生成します。',
    overview: `動画生成は、プロンプトを動くショットに変換します。より細かく制御したい場合は、開始フレーム、終了フレーム、参照画像を追加します。モデルによって対応する制御は異なります。正確なカメラワークのために開始・終了フレームを受け付けるモデルもあれば、テキストだけで使うのが得意なモデルもあります。

尺、解像度、アスペクト比はモデルによって異なります。Martiniは画面を統一しているため、意図を設定しながら各モデルが受け付けるパラメータを確認できます。`,
  },
  'generation/models': {
    source_en_hash: 'v1:1zivmdgst0h',
    title: 'モデル',
    description: 'Veo、Kling、Soraなどを使い分けるタイミング。',
    overview: `モデルにはそれぞれ得意分野があります。Veoはカメラ制御や開始・終了フレームの構成に強く、Klingは高速で動きに優れています。Soraには独特の映画的なルックがあります。Wanはスタイライズされたコンテンツに向いています。Rayは画像と動画の両方を生成します。

モデルピッカーには、各モデルが動画生成、画像生成、またはその両方のどれに対応しているかが表示されます。すべてのモデルがすべてのパラメータを受け付けるわけではありません。機能が多いモデルではなく、ショットに合うモデルを選んでください。使わないモデルは環境設定で非表示にできます。`,
  },
  'generation/prompting': {
    source_en_hash: 'v1:xyd9da5qjl',
    title: 'プロンプト',
    description: '映画的な結果につながるプロンプトを書きます。',
    overview: `プロンプトは説明文ではなく、演出指示です。撮影監督やVFXスーパーバイザーに伝えるように、カメラの動き、ライティング、テンポ、ショットの感触を書きます。抽象的な指示よりも、具体的で物理的な言葉のほうがうまく機能します。

「手持ちのフォローショット、窓から入る自然光、被写体がゆっくり振り向く」は、「美しい映画的な人物のショット」よりも強い指示です。カメラの動き、光源、アクションを指定してください。「stunning」や「breathtaking」のような形容詞は、明確なモデル指示に変換されにくいため避けます。

再生成する前に、プロンプトの意味のある部分を1つずつ変えてください。そうすると、何がショットを改善したのかを判断しやすくなります。`,
  },
  'generation/upscaling': {
    source_en_hash: 'v1:1th5x70ufdk',
    title: 'アップスケール',
    description: '解像度を上げる、ディテールを強調する、または HDR に変換します。',
    overview: `アップスケールは、完成したショットの解像度を高める機能で、ディテールを強調したりHDRに変換したりすることもできます。動画にも画像にも使えます。ショットまたは画像を選択し、右クリックメニュー、インスペクター、または ||U|| キーを押して Upscale & Enhance を選びます。

![](/docs-imgs/generationUpscale.mp4)

Source（ソース）: どのバージョンのショットを元にするか。通常はオリジナルです。情報アイコンをクリックすると、オリジナルの詳細（寸法、ファイル形式、作成日時、アセットID）を確認できます。

Preset（プリセット）: モデル、解像度、画質、エンコーダーなど、以下のすべての設定をまとめて名前を付けて保存したものです。Custom はすべてを手動で設定している状態を意味します。気に入った組み合わせができたら、プラスをクリックして名前付きのプリセットとして保存し、後で再利用できます。プリセットはチームと共有されるので、プロジェクト全体で同じルックや仕様をそろえられます。

Operation（操作）: Upscale は解像度とディテールを高め、Enhance はノイズやブレを取り除いて画像を復元し、HDR は10-bitまたは16-bitのハイダイナミックレンジファイルを出力します。

Model（モデル）: 処理を行うエンジンです。Proteus のような汎用モデルはほとんどのショットに適しており、ディテール・補正系のモデルはシャープネスや特定の問題に対応し、Starlight ファミリーは最高品質を実現します。画像のアップスケールには、専用の高速モデルと生成モデルがあります。

Resolution（解像度）: 出力サイズの目標で、HD から 8K まで選べます。Martini は拡大率（例えば 4x）と各コーデックで許可される最大値を表示します。

Quality（画質）: モデルがどれだけ画像を整えてシャープにするかを決めます。既定では自動で、Martini が適切な設定を選んでくれます。ルックを細かく調整したいときだけ、手動コントロール（ディテール、ノイズ、ブレ、グレイン、圧縮）を追加します。

Output（出力）: エンコーダーは、結果を保存する形式です。H.265、H.264、AV1 に加え、HDR や ProRes の納品形式があります。圧縮はファイルサイズと画質のトレードオフで、Low はファイルが大きくなる代わりにディテールを最も多く残し、High はその逆です。

Frame rate（フレームレート）: 1秒間に再生するフレーム数です。レートが高いほど滑らかに見えます。Auto はソース動画のレートを維持し、24、30、60 fps などのカスタム値を設定することもできます。

結果は同じスタック内に新しいバージョンとして追加されるので、オリジナルとアップスケール後のバージョンを切り替えて見比べられます。

Olive（オリーブ）のコストはモデルと出力サイズによって変わります。動画は出力1秒あたり、画像はメガピクセルあたりで課金され、Starlight のような高品質モデルほどコストが高くなります。

![](/docs-imgs/upscale.png)`,
  },
  'generation/credits': {
    source_en_hash: 'v1:101i5vr0a9y',
    title: 'Olive',
    description: '生成コストの仕組み。',
    overview: `OliveはMartiniの使用単位です。すべての生成にOliveがかかります。必要量はモデル、解像度、尺によって変わります。残高はアカウントメニューで確認できます。

なくなったら、追加購入するかプランをアップグレードできます。生成に失敗した場合、MartiniはOliveを自動で返却します。生成前に計画できるよう、対応モデルページにはモデルごとのコストが表示されています。`,
  },
  'sets/overview': {
    source_en_hash: 'v1:cbl38tqd8g',
    title: '概要',
    description: '1枚の画像から作る3D環境。',
    overview: `セットは、1枚の画像から構築される3D環境です。参照写真をアップロードまたは生成すると、Martiniがそこから移動可能な3D空間を作ります。セットは仮想ロケーションだと考えてください。その中でカメラを動かし、キャラクターを配置し、特定の角度からショットを生成できます。

これは、実際のロケハンや物理セットの構築に最も近い機能です。同じロケーション、異なるカメラ位置、ショットをまたいだ一貫した地理関係を扱えます。`,
  },
  'sets/creating': {
    source_en_hash: 'v1:2enib07kray',
    title: 'セットを作成する',
    description: '画像を移動可能な3D空間に変換します。',
    overview: `生成またはアップロードした画像から始めます。Martiniはその画像から移動可能な3D環境を構築します。処理には数分かかります。

完了すると、セットはキャンバス上のノードとして表示されます。ダブルクリックするとセットビューアーが開き、3D空間を移動できます。`,
  },
  'sets/characters': {
    source_en_hash: 'v1:23pqljuiw5c',
    title: 'キャラクター',
    description: 'セットベースのショットで一貫したキャスティングを保ちます。',
    overview: `キャラクターは、セット内に配置される永続的なアイデンティティです。キャラクターシートをアップロードまたは生成すると、Martiniが人物を検出し、衣装を抽出し、再利用可能な参照を作成します。

セットから生成すると、キャラクターは3D空間内に現れます。これにより、同じ人物、同じ衣装、異なるフレーミングという形で、カメラアングルをまたいだキャスティングの一貫性を保てます。`,
  },
  'sets/viewer': {
    source_en_hash: 'v1:up8l8cp3q2',
    title: 'セットビューアー',
    description: '3D環境を移動し、カメラを配置します。',
    overview: `セットビューアーは、キャンバス内に埋め込まれた3Dビューポートです。ドラッグでオービット、スクロールでズーム、右ドラッグでパンします。仮想カメラを環境内で動かしている状態です。

どの位置からでも、スクリーンショットを参照フレームとしてキャプチャしたり、その正確な角度からショットを生成したりできます。カメラ位置、キャラクター、環境はすべて生成プロンプトに自動で反映されます。`,
  },
  'timeline/overview': {
    source_en_hash: 'v1:qfy9vuw7gs',
    title: '概要',
    description: 'ショットをつないでシーケンスを組み立てます。',
    overview: `タイムラインは、ショットをシーケンスにする場所です。キャンバスからショットをトラックへドラッグし、順番に並べ、トリムし、カットをプレビューします。PremiereやDaVinciの代替ではありませんが、ラフカットを組み、タイミングを確認し、仕上げ用パッケージを書き出すには十分です。

ツールバーのモード切り替えで、キャンバスとタイムラインを行き来します。キャンバスは生成と整理の場所です。タイムラインは編集の場所です。`,
  },
  'timeline/clips': {
    source_en_hash: 'v1:ha0n4cjv11',
    title: 'ショットとトラック',
    description: 'ショットをタイムラインに追加し、トラック上で並べます。',
    overview: `キャンバスからショットをタイムラインへドラッグすると、編集に追加できます。タイムライン上のショットは互いに、また再生ヘッドにスナップします。端をドラッグしてトリムします。必要なだけトラックを使えます。

別々のトラックにショットを重ねれば、レイヤーとして扱えます。タイムライン上のショットを右クリックすると、削除、スリップ、差し替えなどのオプションが表示されます。`,
  },
  'timeline/audio': {
    source_en_hash: 'v1:1hlcrir9yjf',
    title: '音声',
    description: '波形、ナレーション、音楽。',
    overview: `音声は専用トラックに配置されます。タイムラインへ直接、またはキャンバスからファイルをドラッグして音声を読み込めます。波形はインライン表示されるため、カットをビートやセリフに合わせられます。

ナレーションと音楽トラックも同じように扱えます。配置して位置を調整します。Veo 3など音声生成に対応したモデルは、埋め込み音声付きのショットを生成し、その音声はタイムラインにも引き継がれます。`,
  },
  'timeline/playback': {
    source_en_hash: 'v1:pq7zgl6nne',
    title: '再生',
    description: 'トランスポート操作で編集をプレビューします。',
    overview: `||Space|| で再生と一時停止を切り替えます。||J||/||K||/||L|| で後方スクラブ、停止、前方スクラブを行います。再生ヘッドはプログラムモニターに現在のフレームを表示します。

Premiere、Avid、DaVinciと同じトランスポート操作です。身についた操作感をそのまま使えます。`,
  },
  'timeline/sequences': {
    source_en_hash: 'v1:mlutts77ri',
    title: 'シーケンス',
    description: '編集をシーンごとに整理します。',
    overview: `シーケンスを使うと、タイムラインをシーン単位に分けられます。各シーケンスは独立した編集で、全体を組み立てる前に個別のシーンに集中したいときに便利です。

シーケンスを切り替えれば、文脈を失わずにプロジェクト内の別の部分へ集中できます。従来のオフライン編集におけるリールや幕のようなものだと考えてください。`,
  },
  'export/overview': {
    source_en_hash: 'v1:107qvtix405',
    title: '概要',
    description: 'Martiniから作業を書き出します。',
    overview: `書き出しは、Martiniでの作業を外に出す工程です。単体動画としてMP4をレンダーするか、Premiere、DaVinci Resolve、CapCutで仕上げるためのXMLパッケージを書き出します。XMLパッケージにはメディアファイルとタイムライン構造が含まれるため、編集ソフトで開いて作業を続けられます。

どの形式を使うかは、プロジェクトの次の行き先によります。レビューや納品にはMP4。ポストプロダクションにはXMLを使います。`,
  },
  'export/mp4': {
    source_en_hash: 'v1:17a7qgub68u',
    title: 'MP4',
    description: '直接動画を書き出します。',
    overview: `単体の動画ファイルが必要なときはMP4に書き出します。解像度と品質を選び、レンダーします。出力には、現在のトリムポイントを反映したすべてのタイムラインショットが順番に含まれます。

ラフカット、クライアントレビュー、SNSなど、動画自体が最終納品物になる場面に向いています。`,
  },
  'export/nle': {
    source_en_hash: 'v1:1wma3l4cdj8',
    title: 'XML書き出し',
    description: 'Premiere、DaVinci、CapCut向けに書き出します。',
    overview: `Premiere Pro、DaVinci Resolve、CapCutで仕上げたい場合は、XMLパッケージを書き出します。パッケージには、Martiniのタイムラインからメディア、トラック、タイミングが引き継がれます。

カラーグレーディング、サウンドデザイン、VFX仕上げが必要なプロジェクトではXMLを使います。XMLには編集決定リストが、メディアフォルダにはショットが入ります。`,
  },
  'teams/overview': {
    source_en_hash: 'v1:1nwl3a18oii',
    title: '概要',
    description: '組織向けの共有ワークスペース。',
    overview: `チームは、スタジオやエージェンシー向けの共有ワークスペースです。メンバーは請求、モデルアクセス設定、プロジェクト所有権を共有します。チーム管理者は、誰が参加できるか、どのモデルを使えるか、各メンバーがどれだけ使えるかを管理します。

チームはアカウント設定から作成します。メールでメンバーを招待します。チーム内で作成されたプロジェクトはすべてのメンバーに表示され、チームのOlive残高から消費されます。`,
  },
  'teams/members': {
    source_en_hash: 'v1:10exf22pba9',
    title: 'メンバーとロール',
    description: '招待と権限。',
    overview: `メンバーはメールで招待します。管理者はメンバーの追加と削除、チーム設定の調整、使用量の管理を行います。メンバーはチームプロジェクト内で作業し、チーム請求から利用します。

誰かがチームを離れても、その人のプロジェクトは残ります。失われるものはありません。`,
  },
  'teams/billing': {
    source_en_hash: 'v1:vbh19d66ga',
    title: 'チーム請求',
    description: '共有請求と使用上限。',
    overview: `チームは1つの請求アカウントを共有します。プランはチーム全体に適用され、すべてのメンバーが同じOlive残高を使います。管理者はメンバーごとの使用上限を設定してコストを管理できます。

請求履歴と請求書では、メンバー別、プロジェクト別に使用量を確認できます。Oliveがどこに使われたかを正確に把握できます。`,
  },
  'teams/models': {
    source_en_hash: 'v1:4buzhbqg6r',
    title: 'モデル管理',
    description: 'チームで使うモデルを有効化または無効化します。',
    overview: `チーム管理者は、特定のAIモデルを有効化または無効化できます。あるモデルが高価だったり、用途に対して不安定だったりする場合はオフにできます。チームメンバーのモデルピッカーには表示されません。

これにより、画面を絞り込み、コストを予測しやすくできます。モデル一覧はチーム設定からいつでも変更できます。`,
  },
  'account/profile': {
    source_en_hash: 'v1:19bd8xdwqco',
    title: 'プロフィール',
    description: 'エイリアスとメールアドレス。',
    overview: `エイリアスは、Martini全体であなたを識別します。プロジェクト上のカーソル、共同作業、アカウントメニューに使われます。メールアドレスはログイン、請求書、チーム招待に使われます。

プロフィールはアカウント設定ページから更新できます。`,
  },
  'account/preferences': {
    source_en_hash: 'v1:19yltxzw1cu',
    title: '環境設定',
    description: '非表示モデルとワークフロー設定。',
    overview: `使わないモデルを生成パネルから非表示にできます。環境設定はアカウントごとに保存され、プロジェクトやチームをまたいで引き継がれます。

VeoとKlingだけを使う場合は、それ以外を非表示にしてください。生成パネルがすっきりし、使わないモデルをスクロールで通り過ぎる必要がなくなります。`,
  },
  'account/billing': {
    source_en_hash: 'v1:s6ohjzhuxy',
    title: '請求',
    description: 'プラン、Olive、取引履歴、請求書。',
    overview: `現在のプラン、Olive残高、取引履歴は請求ページで確認できます。アップグレード、ダウングレード、追加購入はいつでもできます。請求書もダウンロードできます。

使用量の内訳では、プロジェクトごとのコストを確認できるため、Oliveがどこに使われたかが分かります。チームに所属している場合、チーム請求はチーム管理者が別途管理します。`,
  },
  mcp: {
    source_en_hash: 'v1:1hqksqxtlfe',
    title: 'MCPセットアップ',
    description: 'MCP対応エージェントをMartiniプロジェクトに接続します。',
    overview: `Martiniには組み込みのMCPサーバーがあり、エージェントがプロジェクト内で作業できます。Claude、Cursor、または独自ツールを接続して、プロジェクト状態の読み取り、キャンバスオブジェクトの作成、生成のトリガー、キャンバス管理を行えます。

一度セットアップすれば、任意のMCP対応エージェントから制作タスクを自動化できます。`,
  },
} satisfies Record<string, DocsPageTranslation>
